import axios from 'axios';
import * as types from '../mutation-types';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    maxRows: 0,
    tenants: [],
    roles: [],
    permissions: [],
    countries: [],
    shops: [],
    devices: [],
    shopGroups: [],
    firewalls: [],
    lotterySystems: [],
    users: [],
    lotteryEvents: [],
    players: [],
    onlinePlayers: [],
    thirdPartyPlayers: [],
    terminals: [],
    companies: [],
    products: [],
    banks: [],
    operators: [],
    subtypes: [],

    loading: {
      tenants: {
        state: false,
        promise: null,
      },
      companies: {
        state: false,
        promise: null,
      },
      roles: {
        state: false,
        promise: null,
      },
      permissions: {
        state: false,
        promise: null,
      },
      countries: {
        state: false,
        promise: null,
      },
      shops: {
        state: false,
        promise: null,
      },
      devices: {
        state: false,
        promise: null,
      },
      shopGroups: {
        state: false,
        promise: null,
      },
      firewalls: {
        state: false,
        promise: null,
      },
      lotterySystems: {
        state: false,
        promise: null
      },
      users: {
        state: false,
        promise: null
      },
      lotteryEvents: {
        state: false,
        promise: null
      },
      players: {
        state: false,
        promise: null
      },
      onlinePlayers: {
        state: false,
        promise: null
      },
      thirdPartyPlayers: {
        state: false,
        promise: null
      },
      terminals: {
        state: false,
        promise: null
      },
      products: {
        state: false,
        promise: null
      },
      banks: {
        state: false,
        promise: null
      },
      operators: {
        state: false,
        promise: null
      },
      subtypes: {
        state: false,
        promise: null
      },
    }
  },
  // -----------------------------------------------------------------
  getters: {
    // getters and computed props on the audits data
    tenants: state => state.tenants,
    companies: state => state.companies,
    roles: state => state.roles,
    permissions: state => state.permissions,
    countries: state => state.countries,
    shops: state => state.shops,
    devices: state => state.devices,
    shopGroups: state => state.shopGroups,
    firewalls: state => state.firewalls,
    users: state => state.users,
    lotterySystems: state => state.lotterySystems,
    lotteryEvents: state => state.lotteryEvents,
    players: state => state.players,
    onlinePlayers: state => state.onlinePlayers,
    thirdPartyPlayers: state => state.thirdPartyPlayers,
    terminals: state => state.terminals,
    products: state => state.products,
    banks: state => state.banks,
    operators: state => state.operators,
    subtypes: state => state.subtypes,

    tenantByID: state => id => {
      for (const tenant of state.tenants) {
        if (tenant.eid === id) return tenant;
      }
      return undefined;
    },
    companyByID: state => id => {
      for (const company of state.companies) {
        if (company.eid === id) return company;
      }
      return undefined;
    },
    roleByID: state => id => {
      for (const role of state.roles) {
        if (role.eid === id) return role;
      }
      return undefined;
    },
    permissionByName: state => name => {
      for (const permission of state.permissions) {
        if (permission.name === name) return permission;
      }
      return undefined;
    },
    countryByID: state => id => {
      for (const country of state.countries) {
        if (country.eid === id) return country;
      }
      return undefined;
    },
    shopByID: state => id => {
      for (const shop of state.shops) {
        if (shop.eid === id) return shop;
      }
      return undefined;
    },
    deviceByID: state => id => {
      for (const device of state.devices) {
        if (device.eid === id) return device;
      }
      return undefined;
    },
    shopGroupByID: state => id => {
      for (const shopGroup of state.shopGroups) {
        if (shopGroup.eid === id) return shopGroup;
      }
      return undefined;
    },
    firewallByID: state => id => {
      for (const firewall of state.firewalls) {
        if (firewall.eid === id) return firewall;
      }
      return undefined;
    },
    lotterySytemByID: state => id => {
      for (const lotterySytem of state.lotterySystems) {
        if (lotterySytem.eid === id) return lotterySytem;
      }
      return undefined;
    },
    userByID: state => id => {
      for (const user of state.users) {
        if (user.eid === id) return user;
      }
      return undefined;
    },
    userByUsername: state => username => {
      for (const user of state.users) {
        if (user.username === username) return user;
      }
      return undefined;
    },
    lotteryEventByID: state => id => {
      for (const lotteryEvent of state.lotteryEvents) {
        if (lotteryEvent.eid === id) return lotteryEvent;
      }
      return undefined;
    },
    playerByID: state => id => {
      for (const player of state.players) {
        if (player.eid === id) return player;
      }
      return undefined;
    },
    onlinePlayerByID: state => id => {
      for (const onlinePlayer of state.onlinePlayers) {
        if (onlinePlayer.eid === id) return onlinePlayer;
      }
      return undefined;
    },
    thirdPartyPlayerByID: state => id => {
      for (const thirdPartyPlayer of state.thirdPartyPlayers) {
        if (thirdPartyPlayer.eid === id) return thirdPartyPlayer;
      }
      return undefined;
    },
    terminalByAppID: state => id => {
      for (const terminal of state.terminals) {
        if (terminal.app_id === id) return terminal;
      }
      return undefined;
    },
    terminalByID: state => id => {
      for (const terminal of state.terminals) {
        if (terminal.eid === id) return terminal;
      }
      return undefined;
    },
    productByID: state => id => {
      for (const product of state.products) {
        if (product.eid === id) return product;
      }
      return undefined;
    },
    bankByID: state => id => {
      for (const bank of state.banks) {
        if (bank.eid === id) return bank;
      }
      return undefined;
    },
    operatorByID: state => id => {
      for (const operator of state.operators) {
        if (operator.eid === id) return operator;
      }
      return undefined;
    },
    subtypeByID: state => id => {
      for (const subtype of state.subtypes) {
        if (subtype.eid === id) return subtype;
      }
      return undefined;
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    [types.CACHE_INVALIDATE](state, key) {
      state[key] = [];
    },
    [types.CACHE_LOAD](state, {
      key,
      rows
    }) {
      state[key] = rows;
    },
    [types.CACHE_INVALIDATE_ALL](state) {
      state.tenants = [];
      state.roles = [];
      state.permissions = [];
      state.countries = [];
      state.shops = [];
      state.devices = [];
      state.shopGroups = [];
      state.firewalls = [];
      state.lotterySystems = [];
      state.users = [];
      state.lotteryEvents = [];
      state.players = [];
      state.onlinePlayers = [];
      state.thirdPartyPlayers = [];
      state.terminals = [];
      state.companies = [];
      state.products = [];
      state.banks = [];
      state.operators = [];
      state.subtypes = [];
    }
  },
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, param) => {
      let key;
      let paginationDateData = {};
      let filterData = {};
      let force = false;
      if (typeof param === "string") {
        key = param;
      } else {
        key = param.key;
        paginationDateData = param.dateData;
        filterData = param.filterData;
        force = param.force ? param.force : false;
      }

      if (context.state[key].length && !force) {
        return new Promise((resolve, reject) => {
          resolve(context.state[key]);
        });
      }

      if (context.state.loading[key].state) {
        return context.state.loading[key].promise;
      }
      context.state.loading[key].state = true;

      const paginationData = {
        rowsPerPage: context.state.maxRows,
        page: 0,
        sortDirection: ["ASC"],
        ...paginationDateData,
        ...filterData,
      };

      switch (key) {
        case "permissions":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["name"];
          break;
        case "tenants":
          paginationData.sortBy = ["brand_name"];
          paginationData.fields = ["id", "brand_name", "company_id"];
          break;
        case "companies":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "name"];
          break;
        case "shops":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "name", "tenant_id", "code", "company_id", "active"];
          break;
        case "devices":
          paginationData.sortBy = ["shop_id"];
          paginationData.fields = ["id", "uuid", "name", "type", "tenant_id", "shop_id"];
          break;
        case "shopGroups":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "name", "tenant_id", "shop_ids", "firewall_ruleset_id"];
          break;
        case "users":
          paginationData.sortBy = ["username"];
          paginationData.fields = ["id", "username"];
          break;
        case "players":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "name", "surname", "cnp"];
          break;
        case "onlinePlayers":
          paginationData.sortBy = ["email"];
          paginationData.fields = ["id", "email", "third_party_player_ids"];
          break;
        case "thirdPartyPlayers":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "tenant_id", "shop_id", "name", "surname", "email", "external_id"];
          break;
        case "lotteryEvents":
          paginationData.sortBy = ["system_name"];
          paginationData.fields = ["id", "system_name", "schedule_time", "n", "r"];
          break;
        case "terminals":
          paginationData.sortBy = ["app_id"];
          paginationData.fields = ["id", "shop_id", "app_id", "name"];
          break;
        case "banks":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "name", "account"];
          break;
        case "operators":
          paginationData.sortBy = ["full_name"];
          paginationData.fields = ["id", "full_name", "cnp"];
          break;
        case "subtypes":
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "name", "observation"];
          break;
        default:
          paginationData.sortBy = ["name"];
          paginationData.fields = ["id", "name"];
      }

      const api = {
        "tenants": "tenant/fetch",
        "companies": "company/fetch",
        "roles": "role/fetch",
        "countries": "country/fetch",
        "permissions": "permissions/fetch",
        "shops": "shop/fetch",
        "devices": "devices/fetch",
        "firewalls": "firewall/fetch",
        "shopGroups": "shopGroup/fetch",
        "lotterySystems": "lotterySystem/fetch",
        "lotteryEvents": "lotteryEvent/fetch",
        "users": "user/fetch",
        "players": "player/fetch",
        "onlinePlayers": "onlinePlayer/fetch",
        "thirdPartyPlayers": "thirdPartyPlayer/fetch",
        "terminals": "terminal/fetch",
        "products": "product/fetch",
        "banks": "bank/fetch",
        "operators": "operator/fetch",
        "subtypes": "subtype/fetch",
      };

      const prm = (k) => {
        return new Promise((resolve, reject) => {
          context.dispatch(api[k], paginationData, {
            root: true
          })
            .then((resp) => {
              if (resp.success) {
                if (!resp.data.rows) resp.data.rows = [];
                context.commit(types.CACHE_LOAD, {
                  key: k,
                  rows: resp.data.rows
                });
                resolve(resp.data.rows);
              }
            }).catch((err) => {
              reject(err);
            }).finally(() => {
              context.state.loading[k].state = false;
            });
        });
      };

      context.state.loading[key].promise = prm(key);

      return context.state.loading[key].promise;
    },
  }
};
